export enum GenderEnum {
  Female = 1,
  Male = 2,
}
